import { useQuery } from '@tanstack/react-query';
import useGetMarketingData from './useGetMarketingData';
import { getSegments } from '../../services/marketing';

function useGetSegments() {
  const { data: marketingData, isFetching: isFetchingMarketing } =
    useGetMarketingData();

  const { data, isFetching, isLoading, isError, error, isSuccess, refetch } =
    useQuery({
      queryKey: ['marketing-segments', marketingData?.id],
      queryFn: async () => {
        const result = await getSegments(marketingData?.id!);
        return result;
      },
      enabled: !!marketingData?.id && !isFetchingMarketing,
      staleTime: 0,
      gcTime: 0,
    });

  return {
    data,
    isFetching,
    isLoading,
    isError,
    error,
    isSuccess,
    refetch,
  };
}

export default useGetSegments;
